import React, { PureComponent as Component } from 'react'
import {Redirect} from "react-router-dom"; 
import { MCbrowser } from '../../Context/browserContext';

class Home extends Component{
    render() {
        let isLogined=this.context.isLoggedIn; 
        if(isLogined===true){
            return (
                <Redirect to="/membership" />
            )
        }else{
            return (
                <Redirect to="/auth/login" />
            )
        }
    }
}
Home.contextType = MCbrowser;

export default Home;